import React from 'react'
import Hero from '../components/Hero.jsx'

function Home() {
  return (
    <>
      <Hero/>
    </>
  )
}

export default Home
